export default {
  'zh-CN': {
    privacyPolicy: {
      title: '隐私政策',
      updated: '最后更新：2026-01-20',
      intro: '本隐私政策说明 Fuzozo（“我们”）在您使用移动应用时如何收集、使用和保护您的信息。',
      sections: [
        { title: '1. 我们收集的信息', paragraphs: ['当您使用应用时，我们会收集以下信息：', '我们不会收集密码或其他敏感个人信息。'], bullets: [{ title: 'Google 账号信息', children: ['邮箱地址（通过 Google 登录提供）'] }] },
        { title: '2. 我们如何使用您的信息', paragraphs: ['您的信息仅用于以下目的：'], bullets: ['验证您的账号', '在应用内展示基础账号信息', '提供账号相关功能（登录、退出、删除账号）'] },
        { title: '3. 数据共享', paragraphs: ['我们不会出售、出租或向第三方共享您的个人信息。'] },
        { title: '4. 数据存储与安全', paragraphs: ['我们会采取合理措施保护您的信息，所有数据传输均通过安全网络连接进行加密。'] },
        { title: '5. 账号删除', paragraphs: ['您可以随时删除账号及相关个人数据。', '删除账号的方法：', '账号删除后的影响：'], bullets: [{ children: ['打开应用并进入“我的”页面', '点击“账号删除”', '系统会弹出确认对话框，请再次确认', '点击“注销账号”完成申请，或点击“取消”返回'] }, { children: ['您的邮箱地址及关联账号数据将被永久删除', '该操作无法撤销'] }] },
        { title: '6. 儿童隐私', paragraphs: ['本应用不面向 13 岁以下儿童。'] },
        { title: '7. 政策更新', paragraphs: ['我们可能会不时更新本隐私政策，更新内容会发布在本页面。'] },
        { title: '8. 联系我们', paragraphs: ['如有任何问题，请通过以下邮箱联系我们：', 'support{\'@\'}fuzozo.net'], email: 'support{\'@\'}fuzozo.net' }
      ]
    }
  },
  en: {
    privacyPolicy: {
      title: 'Privacy Policy',
      updated: 'Last updated: 2026-01-20',
      intro: 'This Privacy Policy describes how Fuzozo ("we", "our", or "us") collects, uses, and protects your information when you use our mobile application.',
      sections: [
        { title: '1. Information We Collect', paragraphs: ['We collect the following information when you use the app:', 'We do not collect passwords or sensitive personal data.'], bullets: [{ title: 'Google Account Information', children: ['Email address (provided via Google Sign-In)'] }] },
        { title: '2. How We Use Your Information', paragraphs: ['Your information is used only to:'], bullets: ['Authenticate your account', 'Display basic account information within the app', 'Provide account-related functionality (login, logout, account deletion)'] },
        { title: '3. Data Sharing', paragraphs: ['We do not sell, rent, or share your personal information with third parties.'] },
        { title: '4. Data Storage and Security', paragraphs: ['We take reasonable measures to protect your information. All data transmission is encrypted using secure network connections.'] },
        { title: '5. Account Deletion', paragraphs: ['You can delete your account and associated personal data at any time.', 'How to delete your account:', 'Once your account is deleted:'], bullets: [{ children: ['Open the app and go to the Mine tab', 'Tap Account Deletion', 'A confirmation dialog will appear asking you to confirm the deletion', 'Tap Deactivate Account to complete the request, or tap Cancel to go back'] }, { children: ['Your email address and associated account data will be permanently removed', 'This action cannot be undone'] }] },
        { title: '6. Children\'s Privacy', paragraphs: ['This app is not intended for children under the age of 13.'] },
        { title: '7. Changes to This Policy', paragraphs: ['We may update this Privacy Policy from time to time. Changes will be posted on this page.'] },
        { title: '8. Contact Us', paragraphs: ['If you have any questions, please contact us at:', 'support{\'@\'}fuzozo.net'], email: 'support{\'@\'}fuzozo.net' }
      ]
    }
  },
  ja: {
    privacyPolicy: {
      title: '株式会社Fuzozo プライバシーポリシー',
      updated: '制定日：2026年8月5日 施行日：2026年8月5日 最終改訂日：2026年8月5日 バージョン：1.0',
      intro: '株式会社Fuzozo（以下「当社」といいます。）は、当社が提供するAI技術を利用したコミュニケーションロボット「Fuzozo（フゾゾ）」（以下「本製品」といいます。）、本製品に関連するアプリケーション、当社ウェブサイト、オンラインストアその他の関連サービス（以下総称して「本サービス」といいます。）における個人情報その他の利用者に関する情報の取扱いについて、以下のとおり定めます。',
      sections: [
        {
          title: '1．ご案内内容',
          blocks: [
            {
              type: 'paragraph',
              text: '本ポリシーは、本製品およびアプリの利用、当社ウェブサイトおよびオンラインストアの閲覧・会員登録・購入、ならびにお問い合わせ、修理その他のサポートに伴う情報の取扱いに適用されます。'
            },
            {
              type: 'paragraph',
              text: '当社以外の事業者が運営する販売サイト、アプリストア、決済サービスその他のサービスにおける情報の取扱いには、当該事業者の定めるプライバシーポリシー等が適用されます。当社が当該事業者から情報の提供を受けた後の取扱いには、本ポリシーが適用されます。'
            },
            {
              type: 'paragraph',
              text: '本ポリシーにおいて、用語の意味は次のとおりです。'
            },
            {
              type: 'unorderedList',
              items: [
                '「利用者」とは、本サービスのアカウントを登録した方、および本製品または本サービスを使用する方をいいます。',
                '「本人」とは、個人情報によって識別される特定の個人をいいます。本人には、利用者のほか、本製品に対して発話し、または本製品の周囲において発話した結果、その音声が本製品により取得された方が含まれます。',
                '「法定代理人」とは、親権者その他法令上の代理権を有する方をいいます。'
              ]
            }
          ]
        },
        {
          title: '2．取得する情報と利用目的',
          blocks: [
            {
              type: 'subheading',
              text: '2-1．取得方法'
            },
            {
              type: 'paragraph',
              text: '当社は、利用者による入力または提供、本製品・アプリ・ウェブサイト等の利用に伴う自動的な取得、ならびに販売事業者、決済事業者、配送事業者、認証サービス提供者その他の第三者からの提供により、以下の情報を取得する場合があります。'
            },
            {
              type: 'subheading',
              text: '2-2．取得する情報'
            },
            {
              type: 'unorderedList',
              items: [
                'アカウント・プロフィール情報：氏名、ニックネーム、生年月日または年齢、性別、電話番号、メールアドレス、認証情報、各種設定等',
                '購入・配送等に関する情報：注文内容、購入履歴、配送先、受取人、決済手段の種別、取引に関する情報等。クレジットカード番号等は、決済事業者が直接取得し、当社が直接保有しない場合があります。',
                '音声・会話等に関する情報：本製品またはアプリを通じて取得される音声、音声から生成される文字情報、利用者の入力、AIによる出力、会話履歴、ならびに会話の継続または体験の個別化のために生成・保存される情報等',
                '端末・製品・通信に関する情報：端末の種類、OS、アプリのバージョン、製品固有ID、端末・アプリ識別子、プッシュ通知用情報、IPアドレス、通信状態、言語・タイムゾーン等',
                '利用状況・ログ等に関する情報：本製品のセンサーが検知するタッチ・動作等、利用日時、利用機能、操作履歴、障害・クラッシュ・エラーに関する情報、親密度その他の体験機能に関する記録等',
                'ウェブサイトに関する情報：Cookieその他の識別子、閲覧履歴、参照元、ブラウザ・端末情報等',
                'お問い合わせ等に関する情報：お問い合わせ、修理、返品・交換、アンケート、意見・要望その他当社との連絡内容等'
              ]
            },
            {
              type: 'subheading',
              text: '2-3．利用目的'
            },
            {
              type: 'paragraph',
              text: '当社は、取得した情報を、以下の目的のために利用します。'
            },
            {
              type: 'unorderedList',
              items: [
                'アカウントの登録、認証、管理および本人確認のため',
                '本製品およびアプリの機能を提供するため（音声認識、応答生成、音声合成、会話の継続または体験の個別化のために生成・保存される情報に基づく機能その他の機能を含みます。）',
                '商品の販売、決済、配送、返品・交換、修理、保証対応およびサポートのため',
                '本サービスに関する連絡、プッシュ通知、メンテナンス情報、規約・本ポリシーの変更その他運営上必要な案内を行うため',
                '本サービスの運営、維持、品質管理、不具合対応、障害調査、セキュリティ確保、不正利用の防止および規約違反への対応のため',
                '利用状況の把握・分析、本サービスの改善および新たな機能・サービスの企画・開発のため',
                'お問い合わせ、アンケート、意見・要望等への対応のため',
                '本サービス、キャンペーンその他当社の商品・サービスに関する案内を行うため（法令上または運営上必要な連絡を除き、当社所定の方法により配信停止を求めることができます。）',
                '上記の利用目的に付随する目的、または取得時に別途明示し、もしくは同意を得た目的のため'
              ]
            },
            {
              type: 'paragraph',
              text: '法令で認められる場合を除き、当社は、あらかじめ本人の同意を得ることなく、上記の利用目的の達成に必要な範囲を超えて個人情報を取り扱いません。'
            },
            {
              type: 'subheading',
              text: '2-4．音声・会話情報に関する補足'
            },
            {
              type: 'paragraph',
              text: '本製品は、常時録音、常時撮影または常時監視を目的とする製品ではありません。'
            },
            {
              type: 'paragraph',
              text: '本製品またはアプリを通じて取得する音声および当該音声から生成される文字情報は、第2-3項に記載する目的で処理します。この処理には、第8項に記載する第三者が提供する音声認識、応答生成および音声合成のサービスの利用が含まれます。利用環境によっては、アカウントを登録した方以外の方の音声その他の情報が含まれる場合があり、その場合も本ポリシーに従って取り扱います。'
            },
            {
              type: 'paragraph',
              text: '当社は、本ポリシーの公表その他の方法により、上記の取扱いについて周知します。利用者におかれては、同居のご家族、来訪者その他本製品の周囲におられる方に対し、本製品が音声を取得することをあらかじめお伝えいただくようお願いします。ただし、このお願いは、当社が自ら負う法令上の義務を免れさせるものではありません。'
            },
            {
              type: 'paragraph',
              text: '本製品またはアプリを通じて取得する音声（アカウントを登録した方以外の方の音声を含みます。）、当該音声から生成される文字情報および会話履歴を、声紋モデルその他のAIモデルの訓練、調整または評価に利用することは、第2-3項に定める利用目的には含まれません。将来これらの利用を行う場合、当社は、開始前に本ポリシーを改定し、法令上必要な説明、同意の取得その他の措置を行います。'
            }
          ]
        },
        {
          title: '3．個人情報の共有・提供等',
          blocks: [
            {
              type: 'paragraph',
              text: '当社は、次のいずれかに該当する場合を除き、個人データを第三者に提供しません。'
            },
            {
              type: 'unorderedList',
              items: [
                '本人の同意がある場合',
                '本ポリシーに記載した利用目的の達成に必要な範囲で、個人データの取扱いの全部または一部を委託する場合',
                '合併、会社分割、事業譲渡その他の事由により事業が承継される場合',
                '法令に基づく場合',
                '人の生命、身体または財産の保護、公衆衛生の向上または児童の健全な育成の推進のために必要があり、本人の同意を得ることが困難な場合',
                '国の機関、地方公共団体またはその委託を受けた者による法令上の事務に協力する必要があり、本人の同意を得ることにより当該事務の遂行に支障が生じるおそれがある場合',
                'その他、個人情報保護法その他の法令により認められる場合'
              ]
            },
            {
              type: 'paragraph',
              text: '当社は、個人データの取扱いを委託する場合、委託先に対して必要な保護措置を求めるとともに、法令に従い必要かつ適切に監督します。'
            },
            {
              type: 'paragraph',
              text: '当社は、法令上必要な場合、第三者提供に関する記録を作成し、保存します。本人は、法令に基づき、当該記録の開示を請求することができます。'
            }
          ]
        },
        {
          title: '4．個人情報の保存および安全管理',
          blocks: [
            {
              type: 'subheading',
              text: '4-1．保存期間'
            },
            {
              type: 'paragraph',
              text: '当社は、取得した情報を、利用目的の達成に必要な期間、法令上保存が必要な期間、契約上の義務の履行、紛争・不正利用・セキュリティ上の問題への対応その他正当な目的のために必要な期間保存します。利用する必要がなくなった個人データは、法令に従い、遅滞なく消去するよう努めます。'
            },
            {
              type: 'paragraph',
              text: 'アカウントの削除、退会、アプリの削除または本製品との連携解除が行われた場合でも、法令上の義務、取引記録、問い合わせ・紛争対応、不正利用防止、セキュリティ確保、バックアップその他正当な理由により、一定期間情報が残る場合があります。個人を識別できない統計情報等は、引き続き保有し、利用することがあります。'
            },
            {
              type: 'subheading',
              text: '4-2．国外における取扱い'
            },
            {
              type: 'paragraph',
              text: '本サービスに関する情報の全部または一部は、日本国外に所在するサーバ等で保存され、または日本国外において取り扱われる場合があります。'
            },
            {
              type: 'paragraph',
              text: 'また、本サービスの開発、運用、保守および障害対応のため、当社の委託先において権限を付与された担当者が、日本国外から、当該業務に必要な範囲で本サービスに関する情報にアクセスする場合があります。'
            },
            {
              type: 'paragraph',
              text: '当社は、外国において個人データを取り扱う場合、適用法令に従い、当該外国における個人情報の保護に関する制度その他必要な事項を確認し、必要かつ適切な措置を講じます。'
            },
            {
              type: 'paragraph',
              text: '外国にある第三者に対して個人データを提供する場合、当社は、法令上本人の同意を要しない場合を除き、個人情報保護法に従い、当該第三者が、当社が講ずべきこととされている措置に相当する措置を継続的に講ずるために必要な体制を整備していることを確認し、必要な措置を講ずる方法、または、あらかじめ必要な情報を提供したうえで本人の同意を取得する方法によります。提供先における取扱いおよび当社が講じている措置については、第10項の窓口を通じた本人からの求めに応じて、法令に従い遅滞なく回答します。'
            },
            {
              type: 'paragraph',
              text: '個人データを取り扱う外国の名称および当該外国における個人情報の保護に関する制度の概要についても、同様に、本人からの求めに応じて遅滞なく回答します。取り扱う外国および提供先は、本サービスの内容変更等に伴い変更される場合があります。'
            },
            {
              type: 'subheading',
              text: '4-3．安全管理措置'
            },
            {
              type: 'paragraph',
              text: '当社は、取り扱う情報の性質およびリスクに応じて、個人データの漏えい、滅失、毀損または不正利用を防止するため、必要かつ適切な安全管理措置を講じます。その概要は、以下のとおりです。'
            },
            {
              type: 'unorderedList',
              items: [
                '個人データの取扱いに関する責任・規律および連絡体制の整備',
                '個人データを取り扱う従業者の範囲の限定、教育および監督',
                '個人データを取り扱う機器、媒体等の管理',
                'アクセス制御、認証その他情報システムに対する不正アクセス等の防止',
                '委託先の選定、契約その他の方法による必要かつ適切な監督',
                '外国において個人データを取り扱う場合における外的環境の把握および必要な措置'
              ]
            },
            {
              type: 'paragraph',
              text: '安全管理措置の具体的な内容については、安全管理に支障を及ぼすおそれがある事項を除き、本人からの求めに応じて、法令に従い回答します。'
            }
          ]
        },
        {
          title: '5．保有個人データに関する請求',
          blocks: [
            {
              type: 'paragraph',
              text: '本人または法令上認められる代理人は、当社に対し、個人情報保護法に従い、保有個人データの利用目的の通知、開示、訂正・追加・削除、利用停止・消去、第三者提供の停止および第三者提供記録の開示を請求することができます。'
            },
            {
              type: 'paragraph',
              text: '請求は、第10項の窓口において受け付けます。当社は、請求者の本人確認、代理権の確認および対象情報の特定に必要な情報または書類の提出をお願いする場合があります。法令により請求に応じないことが認められる場合、または当社が合理的な調査を行っても対象情報を特定できない場合には、請求どおりの対応ができないことがあります。'
            },
            {
              type: 'paragraph',
              text: '請求方法その他必要な手続は、当社が別途案内します。利用目的の通知または開示の請求について手数料を定める場合は、その金額および支払方法をあらかじめ公表します。'
            }
          ]
        },
        {
          title: '6．未成年者',
          blocks: [
            {
              type: 'paragraph',
              text: '本製品および本サービスは、15歳以上の方による利用を主な対象とします。'
            },
            {
              type: 'paragraph',
              text: '15歳未満の方が本製品および本サービスを利用する場合、利用規約第3条第2項に従い、親権者その他の法定代理人が利用登録を行い、利用規約上のユーザーとなるものとします。当社に対する必要な同意は、当該法定代理人が行うものとします。'
            },
            {
              type: 'paragraph',
              text: 'この場合、実際に本製品および本サービスを利用する15歳未満の方も、本ポリシーにおける「本人」に含まれます。当社は、本サービスの提供に伴い、当該15歳未満の方に関する情報として、音声、当該音声から生成される文字情報、会話履歴、ならびに会話の継続または体験の個別化のために生成・保存される情報等を取得し、本ポリシーに従って取り扱います。'
            },
            {
              type: 'paragraph',
              text: '15歳以上18歳未満の方が本サービスを利用する場合は、あらかじめ親権者その他の法定代理人の同意を得るものとします。'
            },
            {
              type: 'paragraph',
              text: '当社は、必要に応じて、年齢、法定代理人であること、および法定代理人の同意の有無について、合理的な方法による確認を求めることがあります。'
            },
            {
              type: 'paragraph',
              text: '未成年者に関する保有個人データについては、当該未成年者本人またはその法定代理人が、第5項に定める請求を行うことができます。この場合、当社は、本人確認または法定代理人であることの確認に必要な資料の提出を求めることがあります。'
            }
          ]
        },
        {
          title: '7．本ポリシーの変更',
          blocks: [
            {
              type: 'paragraph',
              text: '当社は、法令の変更、本サービスの内容の変更その他合理的な理由がある場合、本ポリシーを変更することがあります。変更後の内容および適用開始日は、当社ウェブサイト、アプリ内その他当社が適切と判断する方法で掲載または案内します。法令上あらためて本人の同意が必要となる場合には、必要な範囲で同意を取得します。'
            },
            {
              type: 'paragraph',
              text: '当社は、本ポリシーについて、バージョン番号、制定日、施行日および最終改訂日を表示します。'
            }
          ]
        },
        {
          title: '8．第三者サービス等',
          blocks: [
            {
              type: 'paragraph',
              text: '当社は、本サービスの提供にあたり、クラウド、決済、配送、認証、通信、プッシュ通知、障害解析、サポート、ならびに音声認識、応答生成、音声合成その他のAI・APIサービス等、第三者が提供するサービスを利用する場合があります。この場合、当該サービスの提供その他第2項に記載した利用目的の達成に必要な情報が、必要な範囲で、当該事業者に送信され、または当該事業者により取り扱われることがあります。'
            },
            {
              type: 'paragraph',
              text: '本サービスにおいては、利用者の音声を文字情報に変換するために、当該音声を音声認識サービス提供事業者に送信し、当該事業者から文字情報を受領しています。また、応答の生成および音声の合成のために、当該文字情報その他必要な情報を、応答生成サービスおよび音声合成サービスの提供事業者に送信しています。これらの事業者の名称、所在国その他の情報については、第10項の窓口を通じた本人からの求めに応じて、法令に従い遅滞なく回答します。'
            },
            {
              type: 'paragraph',
              text: 'これらの事業者は、日本国外に所在する場合があります。当社は、当該事業者の役割および取扱いの内容に応じて、委託先の監督、本人への情報提供、同意の取得その他法令上必要な対応を行います。'
            },
            {
              type: 'paragraph',
              text: '当社は、第三者が提供するサービスへの情報の送信または提供について、法令上本人の同意が必要となる場合には、当該送信または提供に先立ち、必要な情報を提供したうえで同意を取得します。'
            },
            {
              type: 'paragraph',
              text: '本サービスにおけるCookie、SDKその他の技術を利用した利用者情報の外部送信については、法令に従い、必要な通知、公表、同意の取得その他の対応を行います。利用する外部サービスは、本サービスの内容変更等に伴い変更される場合があります。'
            }
          ]
        },
        {
          title: '9．基本情報',
          blocks: [
            {
              type: 'unorderedList',
              items: [
                '事業者名：株式会社Fuzozo',
                '所在地：〒150-0041 東京都渋谷区神南1-23-14 リージャス渋谷公園通りビル4F',
                '代表者：代表取締役 分部悠介',
                'ウェブサイト：https://www.fuzozo.jp'
              ]
            }
          ]
        },
        {
          title: '10．お問い合わせ',
          blocks: [
            {
              type: 'paragraph',
              text: '本ポリシー、個人情報の取扱い、保有個人データに関する請求および苦情に関するお問い合わせは、以下の窓口までご連絡ください。'
            },
            {
              type: 'unorderedList',
              items: [
                '個人情報・カスタマーサポート窓口：support{\'@\'}fuzozo.jp',
                '一般のお問い合わせ：info{\'@\'}fuzozo.jp'
              ]
            }
          ]
        },
        {
          title: '11．補足事項',
          blocks: [
            {
              type: 'paragraph',
              text: '特定の機能、サービス、キャンペーン、購入方法その他の場面について、本ポリシーとは別に個別の説明、同意画面またはプライバシーに関する案内を表示する場合があります。当該個別の案内は、その対象となる事項について本ポリシーを補足し、内容が異なる場合は、当該対象事項の範囲で個別の案内が優先します。'
            },
            {
              type: 'paragraph',
              text: '以上'
            }
          ]
        }
      ]
    }
  },
  'zh-TW': {
    privacyPolicy: {
      title: '隱私政策',
      updated: '最後更新：2026-01-20',
      intro: '本隱私政策說明 Fuzozo（「我們」）在您使用行動應用程式時如何蒐集、使用與保護您的資訊。',
      sections: [
        { title: '1. 我們蒐集的資訊', paragraphs: ['當您使用應用程式時，我們會蒐集以下資訊：', '我們不會蒐集密碼或其他敏感個人資料。'], bullets: [{ title: 'Google 帳號資訊', children: ['電子郵件地址（透過 Google 登入提供）'] }] },
        { title: '2. 我們如何使用您的資訊', paragraphs: ['您的資訊僅用於以下目的：'], bullets: ['驗證您的帳號', '在應用程式內顯示基本帳號資訊', '提供帳號相關功能（登入、登出、刪除帳號）'] },
        { title: '3. 資料分享', paragraphs: ['我們不會出售、出租或向第三方分享您的個人資訊。'] },
        { title: '4. 資料儲存與安全', paragraphs: ['我們會採取合理措施保護您的資訊，所有資料傳輸皆透過安全網路連線加密。'] },
        { title: '5. 帳號刪除', paragraphs: ['您可以隨時刪除帳號及相關個人資料。', '如何刪除帳號：', '帳號刪除後：'], bullets: [{ children: ['打開應用程式並前往「我的」頁面', '點擊「帳號刪除」', '系統會彈出確認對話框，請再次確認', '點擊「註銷帳號」完成申請，或點擊「取消」返回'] }, { children: ['您的電子郵件地址及相關帳號資料將被永久刪除', '此操作無法復原'] }] },
        { title: '6. 兒童隱私', paragraphs: ['本應用程式不適用於 13 歲以下兒童。'] },
        { title: '7. 政策更新', paragraphs: ['我們可能會不定期更新本隱私政策，更新內容將發布於本頁面。'] },
        { title: '8. 聯絡我們', paragraphs: ['如有任何問題，請透過以下信箱聯絡我們：', 'support{\'@\'}fuzozo.net'], email: 'support{\'@\'}fuzozo.net' }
      ]
    }
  }
}
